<template>
  <div>
    <Header />
    <div class="table-section-instructor">
      <div class="logbook-name">
        <table class="logbook-name-table">
          <tbody>
            <tr>
              <td class="InslogbookName">{{ logbookName }}</td>
              <!-- <td style="border:none; width: 160px;"><button class="inspdfButton" @click="openSignatureModal">Signature</button></td> -->
              <!-- <td style="width: 160px;"><button @click="openLogbookRulesModal" class="inspdfButton">Logbook Rules</button></td> -->
              <td style="width: 160px;"><button @click="showPDFReport" class="inspdfButton">Generate PDF</button></td>
              <td style="width: 160px;"><button @click="openTraineeProgressModal" class="inspdfButton">Progress</button>
              </td>
              <td style="width: 120px;"><button class="back-button" @click="goBack">Back</button></td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="ins-pagination-button-container">
        <div class="ins-pagination-container">
          <Pagination :total-pages="totalPages" :per-page="perPage" :current-page="currentPage"
            @page-change="onPageChange" />
        </div>
        <div class="ins-pagination-info">
          Showing {{ startIndex + 1 }}-{{ endIndex }} of {{ filteredTasks.length }} Tasks
        </div>
      </div>
      <div class="signoff-buttons">
        <button @click="toggleMultiSignOffMode" class="multi-sign-off-button" id="select-all" :disabled="isDisabled">
          {{ multiSignOffMode ? 'De-select All' : 'Select All' }}
        </button>
        <button @click="signOffAll()" class="multi-sign-off-button" id="sign-off-all" :disabled="isDisabled">Sign Off
          All</button>
      </div>
      <div class="flex-grow-1 d-flex justify-content-center" style="margin-bottom: 10px; margin-top: 10px;">
        <div
          v-if="currentEvaluation"
          :class="evaluationStatusClass"
        >
          {{ evaluationStatusText }}
        </div>
      </div>
      <div v-if="isDisabled" class="flex-grow-1 d-flex justify-content-center" style="margin-bottom: 20px;">
        <div class="expired-box">
          This logbook is locked. Tasks can no longer be assigned or signed off.
        </div>
      </div>
      <div class="table-scroll-wrapper">
      <table class="data-table-instructor-logbook">
        <thead>
          <tr>
            <th class="MO">ATA
              <select v-model="selectedChapter">
                <option value="All">All</option>
                <option v-for="chapter in uniqueChapters" :key="chapter" :value="chapter">{{ chapter }}</option>
              </select>
            </th>
            <th class="task-no">Task No</th>
            <!-- <th class="category">Category
              <select v-model="selectedCategory">
                <option value="All">All</option>
                <option v-for="category in uniquecategories" :key="category" :value="category">{{ category }}</option>
              </select>
            </th> -->
            <th class="MO">MT/AT<br>
              <select v-model="selectedMO">
                <option value="All">All</option>
                <option v-for="mo in uniqueMOs" :key="mo" :value="mo">{{ mo }}</option>
              </select>
            </th>
            <th class="scope">Scope
              <select v-model="selectedScope">
                <option value="All">All</option>
                <option v-for="scope in uniquescopes" :key="scope" :value="scope">{{ scope }}</option>
              </select>
            </th>
            <!--<th class="sect-id">Sect ID</th>-->
            <!-- <th v-if="isAssessorSelected" class="is_exam">Being Assessed</th> -->
            <!-- <th v-if="!isAssessorSelected" class="enable" style="border-left: 2px solid black;">Assign Tasks</th> -->
            <th v-if="isAssessorSelected" class="enable">Assessment Complete</th>
            <th class="description">Description</th>
            <th class="reference">Reference</th>
            <th class="scope" style="border-right: 2px solid black;">Category
              <select v-model="selectedCategory">
                <option value="All">All</option>
                <option v-for="category in uniquecategories" :key="category" :value="category">{{ category }}</option>
              </select>
            </th>
            <th class="ac_reg">A/C Reg</th>
            <!-- <th class="ac_reg">Jobcard No</th> -->
            <th class="P1" style="text-align: center;">Classroom</th>
            <th class="P1"
              style="text-align: center; padding-left: 10px; padding-right: 10px; border-right: 2px solid black;">
              Aircraft</th>
            <th class="enable" style="border-left: 2px solid black; border-right: 2px solid black;">Assigned By</th>
            <th class="completed">Date</th>
            <th class="completed">Trainee Sign Off
              <select id="completed-filter" v-model="selectedCompleted" style="width:100%">
                <option value="All tasks">All tasks</option>
              <option value="not enabled tasks">Unassigned</option>
              <option value="enabled tasks">Assigned</option>
              <option value="completed tasks">Signed Off</option>
              <option value="enabled and incomplete tasks">Not Signed Off</option>
              </select>
            </th>
            <th class="inssign" style="width: 8%; border-right: 2px solid black;">Inst. Sign Off
              <select v-model="selectedSignOff" style="width:100%">
                <option value="All tasks">All tasks</option>
                <option value="signed off tasks">Signed Off</option>
                <option value="not signed off tasks">Not Signed Off</option>
              </select>
            </th>
            <!-- <th class="inssign" style="width: 8%">Inst. Stamp</th> -->
            <th v-if="!isAssessorSelected" class="publicnotes">Public Notes
              <select v-model="selectedPublicNotes">
                <option value="All">All</option>
                <option value="has note">Has Note</option>
                <option value="no note">No Note</option>
              </select>
            </th>
            <th v-if="!isAssessorSelected" class="privatenotes">Private Notes
              <select v-model="selectedPrivateNotes">
                <option value="All">All</option>
                <option value="has note">Has Note</option>
                <option value="no note">No Note</option>
              </select>
            </th>
            <!-- <th class="publicnotes">Assess</th> -->
          </tr>
        </thead>

        <!-- TABLE BODY -->
        <tbody>
          <template v-for="(group, chaptNo) in paginatedTasks" :key="chaptNo">
            <!-- Row for the Chapter Name -->
            <tr class="chapter-row">
              <td colspan="100%" class="chapter-name-cell">{{ group.name }}</td>
            </tr>
            <tr v-for="(task, index) in group.tasks" :key="index">
              <td>{{ task.chapt_no }}</td>
              <td @click="openInsTaskLongFormModal(task)" style="color: blue; text-decoration: underline;">{{
                task.task_no
              }}
              </td>
              <!-- <td>{{ task.category }}</td> -->
              <td>{{ task.manob }}</td>
              <td>{{ task.scope }}</td>
              <!-- <td>
              <input type="checkbox" v-model="task.is_exam" @change="toggleIsExam(task)" class="custom-checkbox"
                id="center-icons">
            </td> -->
              <!-- <td v-if="isAssessorSelected">
          <input type="checkbox" v-model="task.being_assessed" @change="toggleBeingAssessed(task)" :disabled="task.is_assessed">
        </td> -->
              <!-- <td v-if="!isAssessorSelected" style="text-align: center; border-left: 2px solid black;">
                <input type="checkbox" style="width: 14px; height: 14px;" v-model="task.enabled"
                  @change="toggleEnabled(task)" :disabled="task.completed || isDisabled">
              </td>
              <td v-else>
                <input type="checkbox" v-model="task.is_assessed" @change="toggleIsAssessed(task)">
              </td> -->
              <td @click="openInsTaskLongFormModal(task)" style="cursor: pointer;">
                <div class="description-cell" :style="{ color: task.is_submitted === 3 ? 'green' : 'blue' }">
                  {{ task.description }}
                </div>
              </td>
              <td>
                <template v-for="(part, index) in splitReference(task.reference)" :key="index">
                  {{ part }}<br v-if="index < splitReference(task.reference).length - 1" />
                </template>
              </td>
              <td style="border-right: 2px solid black;">{{ task.category }}</td>
              <td>
                <div class="ac-reg-container">
                  <input v-if="task.enabled" type="text" v-model="task.ac_reg" class="ac-reg-input" disabled />
                </div>
              </td>
              <!-- <td>
            <div class="jobcard-no-container">
              <input v-if="task.enabled" type="text" v-model="task.jobcard_no" class="jobcard-no-input" disabled />
            </div>
          </td> -->
              <td style="text-align: center;">
                <input style="width: 15px; height: 15px; margin-left: 10px; margin-right: 10px;"
                  type="checkbox" id="P1" name="P1" v-model="task.entry_P1" :disabled="task.ins_so || isDisabled"
                  @change="handleP1P2Change(task, 'P1')" />
              </td>
              <td style="text-align: center; border-right: 2px solid black;">
                <input style="width: 15px; height: 15px; margin-left: 10px; margin-right: 10px;" type="checkbox" id="P2"
                  name="P2" v-model="task.entry_P2" :disabled="task.ins_so || isDisabled"
                  @change="handleP1P2Change(task, 'P2')" />
              </td>
              <td v-if="task.enabled" style="border-left: 2px solid black; border-right: 2px solid black;">
                <b>{{ task.instructor_enabled_name || 'Unknown' }}</b> <br>
              </td>
              <td v-else style="border-left: 2px solid black; border-right: 2px solid black;">
                <div></div>
              </td>
              <td v-if="task.enabled">
                <div>{{ task.selected_date?.split(' ')[0] || '' }}</div>
              </td>
              <td v-else>
                <div></div>
              </td>
              <td v-if="task.completed">
                <!-- <div>{{ task.selected_date?.split(' ')[0] || '' }}</div> -->
                <div v-if="task.t_signature_id" class="signature-container" style="max-height: 40px;">
                  <img :src="findSignatureUrl(task.t_signature_id)" class="signature-image" alt="Signature">
                </div>
                <button v-if="!task.ins_so && !isDisabled" class="instructor_signoff-revoke"
                  @click.prevent="revokeSignOff(task, false)">Revoke</button>
              </td>
              <td v-else>
                <div v-if="!task.completed && task.is_revoked === 1">
                  <button class="instructor_signoff-view-revoke" @click.prevent="openRevokeSignOffModal(task, false, true)">View Revoke</button>
                </div>
              </td>
              <td v-if="multiSignOffMode && !task.ins_so" style="border-right: 2px solid black;">
                <button class="instructor_signoff" :class="{ 'disabled-signoff': !task.completed }"
                  :disabled="!task.completed && !isDisabled" @click.prevent="confirmSignOff(task)">SIGN
                  OFF</button>
                <input type="checkbox" v-if="task.completed && !task.ins_so" v-model="task.selectedForSignOff"
                  @change="toggleSignOff(task)" />
              </td>
              <td v-else style="border-right: 2px solid black;">
                <div v-if="task.ins_so">
                  <b>{{ task.instructor_name }}</b> <br>
                  <!-- <b>{{ task.instructor_license }}</b> -->
                  <!-- {{ task.ins_so?.split(' ')[0] || '' }} -->
                  <div v-if="task.ins_signature_id" class="signature-container" style="max-height: 40px;">
                    <img :src="findInstSignatureUrl(task.ins_signature_id)" class="signature-image" alt="Signature">
                  </div>
                  <button v-if="task.completed && !isDisabled" class="instructor_signoff-revoke"
                    @click.prevent="revokeSignOff(task, true)">
                    Revoke
                  </button>
                </div>
                <div v-else>
                  <button v-if="!isAssessorSelected && !isDisabled" class="instructor_signoff"
                    :class="{ 'disabled-signoff': !task.completed }" :disabled="!task.completed"
                    @click.prevent="confirmSignOff(task)">SIGN OFF</button>
                    <div v-if="!task.ins_so && task.is_inst_revoked === 1">
                      <button class="instructor_signoff-view-revoke" @click.prevent="openRevokeSignOffModal(task, true, true)">View Revoke</button>
                    </div>
                </div>
              </td>
              <!-- <td v-if="task.ins_so">
                <b>{{ task.instructor_name }}</b> <br>
                <b>{{ task.instructor_license }}</b>
              </td>
              <td v-else>
              </td> -->
              <td v-if="!isAssessorSelected">
                <button v-if="task.selected_date" class="notesButton" :disabled="!task.logbookentry_id" @click="openEditor(task.logbookentry_id, true)">
                  <font-awesome-icon icon="sticky-note"
                    title="Add a note for this task. The trainee can also see this note." 
                    :class="{
                      'icon-green': hasPublicNote(task),
                      'icon-grey': !hasPublicNote(task)
                    }" />
                </button>
              </td>
              <td v-if="!isAssessorSelected">
                <button v-if="task.selected_date" class="notesButton" :disabled="!task.logbookentry_id" @click="openEditor(task.logbookentry_id, false)">
                  <font-awesome-icon icon="sticky-note" title="Add a note for this task. Only instructors assigned to the session can view this note."
                    :class="{
                      'icon-green': hasPrivateNote(task),
                      'icon-grey': !hasPrivateNote(task)
                    }" />
                </button>
              </td>
              <!-- <td>
  <div v-if="task.is_assessed">
    <a style="text-decoration: underline; color: blue; cursor: pointer;">View Results</a>
  </div>
  <div v-if="task.being_assessed && !task.is_assessed">
    <a style="text-decoration: underline; color: blue; cursor: pointer;">Assess Trainee</a>
  </div>
</td> -->
            </tr>
          </template>
          <tr v-if="paginatedTasks.length === 0">
            <td colspan="100" style="text-align: center;">No Matching Tasks</td>
          </tr>
        </tbody>
      </table>
      </div>
      <div class="evaluationSection">
        <button v-if="ENABLE_ASSESSMENT" class="evaluationButton" @click="openChooseAssessmentModal()">Task Assessment</button>
        <!-- <button class="addSigButton" @click="addSigToTasks(true)" :disabled="isDisabled">Add Signature to Tasks</button> -->
        <button class="evaluationButton" @click="openChooseEvaluationModal()">Evaluation Sheet</button>
      </div>
    </div>
  </div>
  <QuillEditor v-if="showQuillEditor" :logbookEntryId="logbookentryId" :logbookId="logbookId"
    :is-disabled="locked" userRole="instructor" :noteType="noteType" @close="closeQuillEditor">
  </QuillEditor>
  <ChooseAssessmentModal v-if="showChooseAssessmentModal" :logbook-id="parseInt(logbookId)" :trainee="trainee" :instructor="instructor"
    :merged-tasks="mergedTasks" @close="closeChooseAssessmentModal"></ChooseAssessmentModal>
  <task-assessment-modal v-if="showTaskAssessmentModal" :trainee="trainee" :tasks-count="MTCount"
    :completed-tasks="completedMTCount || 0" :taskAssessmentId="taskAssessmentId" :logbook-id="logbookId"
    :fetched-data="fetchedTaskAssessmentData" :attemptNo="attemptNo" :selectedTask="selectedTask"
    @close="closeTaskAssessmentModal"></task-assessment-modal>
  <InsTaskLongFormModal v-if="showInsTaskLongFormModal" :task="currentTask" :logbook-id="logbookId"
    :chapters="chapters" @close="closeInsTaskLongFormModal"></InsTaskLongFormModal>
  <TraineeProgressModal v-if="showTraineeProgressModal" :logbookId="logbookId" :merged-tasks="mergedTasks" :passRate="currentProduct.pass_rate ?? 50"
    :traineeId="traineeId" @close="closeTraineeProgressModal"></TraineeProgressModal>
  <LogbookRulesModal v-if="showLogbookRulesModal"
    @close="closeLogbookRulesModal"></LogbookRulesModal>
  <choose-evaluation-modal v-if="showChooseEvaluationModal" :tasks-count="tasksCount" :completed-tasks="tasksCompleted"
    :propTasks="mergedTasks" :logbook-id="logbookId" :trainee="trainee" :passRate="currentProduct.pass_rate ?? 50"
    :locked="locked" @close="closeChooseEvaluationModal(submit = false)"></choose-evaluation-modal>
  <signature-modal v-if="showSignatureModal" @close="closeSignatureModal"></signature-modal>
  <logbook-report v-if="displayLogbookReport" :filteredTasks="mergedTasks" :logbookName="logbookName"
    :logbookId="logbookId" :selectedTrainee="trainee" :chapters="chapters" />
  <RevokeSignOffModal v-if="showRevokeSignOffModal" :task-id="currentTaskId" :logbook-id="logbookId"
    :isInstSo="is_inst_so" :logbookentryId="logbookentryId" :instructorId="instructorId" :signOff="signOff" :view-only="viewOnlyRevoke"
    @close="closeRevokeSignOffModal">
  </RevokeSignOffModal>
  <ChooseSignOffDateModal v-if="showChooseSignOffDateModal" :task-id="currentTaskId" :logbook-id="logbookId"
    :logbookentryId="logbookentryId" :instructorId="instructorId" :signOffType="signOffType"
    @signOffDateSelected="handleSignOffDateSelected" @multiDateSelected="handleMultiSignOffDateSelected"
    @close="closeChooseSignOffDateModal">
  </ChooseSignOffDateModal>
</template>

<script>
import Header from '../Examiner/Header.vue';
import axios from 'axios';
import './InstructorLogbook.css';
import Pagination from '@/components/Examiner/TablePagination.vue';
import QuillEditor from '@/components/notes/Note.vue';
import LogbookReport from './InstructorLogbookReport.vue';
import ChooseAssessmentModal from './ChooseTaskAssessmentModal.vue';
import TaskAssessmentModal from '@/components/Instructor/TaskAssessmentModal.vue';
import InsTaskLongFormModal from '@/components/Instructor/InsTaskLongFormModal.vue';
import TraineeProgressModal from '@/components/Trainee/TraineeProgressModal.vue';
import LogbookRulesModal from '@/components/Trainee/LogbookRulesModal.vue';
import RevokeSignOffModal from '@/components/Instructor/RevokeSignOffModal.vue';
import ChooseSignOffDateModal from '@/components/Instructor/ChooseSignOffDateModal.vue';
import ChooseEvaluationModal from '@/components/Instructor/ChooseEvaluationModal.vue';
import SignatureModal from '@/components/Examiner/SignatureModal.vue';
import { ENABLE_ASSESSMENT as ENABLE_ASSESSMENT_FLAG } from '@/config/featureFlags';

export default {
  name: 'InstructorLogbook',
  components: {
    Pagination,
    Header,
    QuillEditor,
    RevokeSignOffModal,
    ChooseSignOffDateModal,
    InsTaskLongFormModal,
    TraineeProgressModal,
    LogbookRulesModal,
    TaskAssessmentModal,
    ChooseEvaluationModal,
    SignatureModal,
    LogbookReport,
    ChooseAssessmentModal,
  },
  data() {
    return {
      logbooks: [],
      tasks: [],
      trainee: [],
      revokes: [],
      logbookName: '',
      productId: localStorage.getItem('productId') || null,
      currentProduct: JSON.parse(localStorage.getItem('currentProduct')) || {},
      logbookId: localStorage.getItem('logbook_id'),
      instructorId: localStorage.getItem('user_id'),
      traineeId: localStorage.getItem('trainee_id'),
      mergedTasks: [],
      editorContent: '',
      showQuillEditor: false,
      showRevokeSignOffModal: false,
      showChooseSignOffDateModal: false,
      showInsTaskLongFormModal: false,
      showTraineeProgressModal: false,
      showLogbookRulesModal: false,
      showTaskAssessmentModal: false,
      showChooseEvaluationModal: false,
      showSignatureModal: false,
      displayLogbookReport: false,
      tasksCount: 0,
      notes: [],
      notesContent: '',
      noteType: '',
      showDropdown: false,
      selectedMO: 'All',
      selectedCompleted: 'All tasks',
      selectedLevel: 'All',
      selectedScope: 'All',
      selectedSkill: 'All',
      selectedisexam: 'All',
      selectedCategory: 'All',
      selectedChapter: 'All',
      selectedSignOff: 'All tasks',
      selectedPublicNotes: 'All',
      selectedPrivateNotes: 'All',
      isSyncing: false,
      isOffline: !navigator.onLine,
      selectedTasks: [],
      multiSignOffMode: false,
      filteredTasksLength: 0,
      currentPage: 1,
      perPage: 10,
      customColor: 'rgb(218, 248, 252, 0.7)',
      MTCount: '',
      completedMTCount: '',
      newTasksToEnable: [],
      oldTasksToEnable: [],
      updateTimer: null, // Timer for batching updates
      updateDelay: 1000,
      signatureId: '',
      instSignatureId: '',
      user_id: null,
      traineeSignatureUrl: null,
      signatureUrl: null,
      signatures: [],
      currentTask: null,
      fetchedTaskAssessmentData: [],
      taskAssessmentId: null,
      selectedTrainee: {},
      showChooseAssessmentModal: false,
      refreshInterval: null,
      isUnmounted: false,
      chapters: [],
      signOff: null,
      instructors: [],
      instructor: [],
      assessment_tasks: [],
      currentTaskId: null,
      logbookentryId: null,
      signOffType: 'single',
      locked: null,
      trainee_evaluations: [],
      logbookEntries: [],
      viewOnlyRevoke: false,
      lastKnownUpdate: null,
      isCheckingForUpdates: false,
    };
  },
  watch: {
    selectedMO(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.calculateTotalPages?.(); // Optional if this method exists
      }
    },
    selectedChapter(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.calculateTotalPages?.();
      }
    },
    selectedScope(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.calculateTotalPages?.();
      }
    },
    selectedSkill(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.calculateTotalPages?.();
      }
    },
    selectedCompleted(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.calculateTotalPages?.();
      }
    },
    selectedSignOff(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.calculateTotalPages?.();
      }
    },
    selectedPublicNotes(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.calculateTotalPages?.();
      }
    },
    selectedPrivateNotes(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.currentPage = 1;
        this.calculateTotalPages?.();
      }
    },
  },
  computed: {
    ENABLE_ASSESSMENT() {
      return ENABLE_ASSESSMENT_FLAG;
    },
    filteredTasks() {
      return this.mergedTasks.filter(task => {
        //this.currentPage = 1;
        const moMatches = this.selectedMO === 'All' || task.manob === this.selectedMO;
        const completedMatches =
          this.selectedCompleted === 'All tasks' ||
          (this.selectedCompleted === 'completed tasks' && task.completed) ||
          (this.selectedCompleted === 'not completed tasks' && !task.completed) ||
          (this.selectedCompleted === 'enabled tasks' && task.enabled) ||
          (this.selectedCompleted === 'not enabled tasks' && !task.enabled) ||
          (this.selectedCompleted === 'enabled and incomplete tasks' && (task.enabled && !task.completed)) ||
          (this.selectedCompleted === 'examinable tasks' && task.is_exam);
        const SignedOffMatches =
          this.selectedSignOff === 'All tasks' ||
          (this.selectedSignOff === 'signed off tasks' && task.ins_so) ||
          (this.selectedSignOff === 'not signed off tasks' && !task.ins_so && task.enabled) ||
          (this.selectedSignOff === 'signed off no signature' && task.ins_so && !task.ins_signature_id);

        const publicNotesMatches =
          this.selectedPublicNotes === 'All' ||
          (this.selectedPublicNotes === 'has note' && this.hasPublicNote(task)) ||
          (this.selectedPublicNotes === 'no note' && !this.hasPublicNote(task));

        const privateNotesMatches =
          this.selectedPrivateNotes === 'All' ||
          (this.selectedPrivateNotes === 'has note' && this.hasPrivateNote(task)) ||
          (this.selectedPrivateNotes === 'no note' && !this.hasPrivateNote(task));
        //const levelMatches = this.selectedLevel === 'All' || task.level === parseInt(this.selectedLevel);
        const scopeMatches = this.selectedScope === 'All' || task.scope === this.selectedScope;
        const skillMatches = this.selectedSkill === 'All' || task.skill === this.selectedSkill;
        const chapterMatches = this.selectedChapter === 'All' || task.chapt_no === this.selectedChapter;
        const categoryMatches = this.selectedCategory === 'All' || task.category === this.selectedCategory;
        const isexamMatches = this.selectedisexam === 'All' || task.is_exam === this.selectedisexam;

        return moMatches && completedMatches && SignedOffMatches && scopeMatches && skillMatches && chapterMatches && categoryMatches && isexamMatches && publicNotesMatches && privateNotesMatches;
      });
    },
    paginatedTasks() {
      const start = this.startIndex;
      const end = this.endIndex;

      const sortedFilteredTasks = [...this.filteredTasks].sort((a, b) => {
        const chapRegex = /^(\d+)([A-Za-z]*)$/;
        const [, numA, suffixA] = (a.chapt_no || '').match(chapRegex) || [];
        const [, numB, suffixB] = (b.chapt_no || '').match(chapRegex) || [];

        const chapterComparison = Number(numA) - Number(numB);
        if (chapterComparison !== 0) return chapterComparison;

        const suffixComparison = (suffixA || '').localeCompare(suffixB || '');
        if (suffixComparison !== 0) return suffixComparison;

        const taskA = parseInt(a.task_no, 10);
        const taskB = parseInt(b.task_no, 10);

        return taskA - taskB;
      });

      const paginatedFilteredTasks = sortedFilteredTasks.slice(start, end);

      return Object.entries(
        paginatedFilteredTasks.reduce((groups, task) => {
          const chapterName = this.getChapterName(task.chapt_no);
          if (!groups[task.chapt_no]) {
            groups[task.chapt_no] = { name: chapterName, tasks: [] };
          }
          groups[task.chapt_no].tasks.push(task);
          return groups;
        }, {})
      )
        .map(([chaptNo, group]) => ({
          chaptNo,
          name: group.name,
          tasks: group.tasks.sort((a, b) => parseInt(a.task_no, 10) - parseInt(b.task_no, 10)),
        }))
        .sort((a, b) => parseInt(a.chaptNo, 10) - parseInt(b.chaptNo, 10));
    },
    uniqueChapters() {
      const chapters = this.tasks.map(task => task.chapt_no);
      return [...new Set(chapters)]; // This will remove any duplicates and return unique values.
    },
    uniqueMOs() {
      const MOs = this.tasks.map(task => task.manob);
      return [...new Set(MOs)];
    },
    uniqueLevels() {
      const levels = this.tasks.map(task => task.level);
      return [...new Set(levels)];
    },
    uniquescopes() {
      const scopes = this.tasks.map(task => task.scope);
      return [...new Set(scopes)];
    },
    uniqueskills() {
      const skills = this.tasks.map(task => task.skill);
      return [...new Set(skills)];
    },
    uniquecategories() {
      const categories = this.tasks.map(task => task.category);
      return [...new Set(categories)];
    },
    totalPages() {
      return Math.ceil(this.filteredTasks.length / this.perPage);
    },
    startIndex() {
      return (this.currentPage - 1) * this.perPage;
    },
    endIndex() {
      const end = this.startIndex + this.perPage;
      return end < this.filteredTasks.length ? end : this.filteredTasks.length;
    },
    localIsAssessorSelected: {
      get() {
        return this.isAssessorSelected;
      },
      set(newValue) {
        this.$emit('update:isAssessorSelected', newValue);
      }
    },
    isDisabled() {
      return this.locked === 1;
    },
    continuousEvaluation() {
    return this.trainee_evaluations.find(e => e.evaluation_type === 'continuous') || null;
    },
    remedialEvaluation() {
      return this.trainee_evaluations.find(e => e.evaluation_type === 'remedial') || null;
    },
    currentEvaluation() {
      // Remedial to take priority when it exists:
      return this.remedialEvaluation || this.continuousEvaluation || null;
    },
    evaluationStatusClass() {
      const evaluation = this.currentEvaluation;
      if (!evaluation) return '';

      if (evaluation.is_submitted === 0) {
        return 'pending-box';
      }

      if (evaluation.is_submitted === 1) {
        return 'pending-box';
      }

      if (evaluation.is_submitted === 2) {
        if (evaluation.evaluation_type === 'continuous' && evaluation.result === 'successful') {
          return 'success-box';
        }

        if (evaluation.evaluation_type === 'continuous' && evaluation.result === 'remedial') {
          return 'expired-box';
        }

        if (evaluation.evaluation_type === 'remedial' && evaluation.result === 'successful') {
          return 'success-box';
        }

        if (evaluation.evaluation_type === 'remedial' && evaluation.result === 'unsuccessful') {
          return 'expired-box';
        }

        return 'success-box';
      }

      return 'pending-box';
    },
    evaluationStatusText() {
      const evaluation = this.currentEvaluation;
      if (!evaluation) return 'No evaluation started';

      if (evaluation.is_submitted === 0) return 'Evaluation in progress';
      if (evaluation.is_submitted === 1) return 'Evaluation awaiting trainee signature';

      if (evaluation.is_submitted === 2) {
        if (evaluation.evaluation_type === 'continuous' && evaluation.result === 'successful') {
          return 'Continuous evaluation passed';
        }
        if (evaluation.evaluation_type === 'continuous' && evaluation.result === 'remedial') {
          return 'Continuous evaluation result: remedial';
        }
        if (evaluation.evaluation_type === 'remedial' && evaluation.result === 'successful') {
          return 'Remedial evaluation passed';
        }
        if (evaluation.evaluation_type === 'remedial' && evaluation.result === 'unsuccessful') {
          return 'Remedial evaluation failed';
        }
        return 'Evaluation signed by trainee';
      }
      return 'Evaluation status unknown';
    },
  },
  methods: {
    goBack(signature=false) {
      if (signature === true) {
        localStorage.removeItem('selectedProject');
      }
      this.$router.push({ name: 'InstructorHome' });
    },
    hasPublicNote(task) {
      return task.notes?.some(n => n.type === 'public' &&
        n.content?.trim() !== '' && n.content?.trim() !== '<p><br></p>') || false;
    },
    hasPrivateNote(task) {
      return task.notes?.some(n => n.type === 'private' && n.role === 'instructor' &&
        n.content?.trim() !== '' && n.content?.trim() !== '<p><br></p>') || false;
    },
    findSelectedSignatureForUser(userId) {
      return this.signatures.find(sig => sig.user_id === userId && sig.is_selected && sig.role === 'instructor') || null;
    },
    getChapterName(chapt_no) {
      const chapter = this.chapters.find((ch) => ch.chapt_no === chapt_no);
      return chapter ? `Chapter ${chapt_no}: ${chapter.name}` : `Chapter ${chapt_no}`;
    },
    splitReference(value) {
      if (!value) return [''];
      return String(value).split('\\');
    },
    async handleP1P2Change(task, changed) {
      // Enforce mutual exclusivity
      if (changed === 'P1' && task.entry_P1) {
        task.entry_P2 = false;
      } else if (changed === 'P2' && task.entry_P2) {
        task.entry_P1 = false;
      }

      this.currentTask = task;
      this.currentTaskId = task.task_id;
      this.logbookentryId = task.logbookentry_id;
      this.signOffType = 'single';
      this.showChooseSignOffDateModal = true;
      return; // stop here — wait for date selection
    },
    async addSigToTasks(manual = false) {
      try {
        const logbookId = this.logbookId;

        // Reuse signatures already loaded in memory (allSignatures() keeps this
        // fresh) instead of re-fetching /api/books on every sign-off.
        const userId = parseInt(localStorage.getItem('user_id'));
        const selectedSig = this.findSelectedSignatureForUser(userId);

        // Filter tasks that need signature
        const filteredSigTasks = this.mergedTasks.filter(task => {
          return (
            task.completed !== null &&
            task.ins_signature_id === null &&
            task.instructor_id === userId
          );
        });
        if (manual === true) {
          if (!selectedSig) {
            alert('You must add a signature to your profile before adding a signature to tasks.\n\nReturn to the instructor home page to add or upload a signature')
            return;
          }
          if (filteredSigTasks.length === 0) {
            alert(`All signed off tasks by ${this.instructor.first_name} ${this.instructor.last_name} already have a signature`)
            return;
          }
          const proceed = confirm(
            `This will add the saved signature to ${filteredSigTasks.length} tasks.\n\nDo you wish to continue?`
          );
          if (!proceed) {
            return; // user cancelled → stop here
          }
        } else {
          if (filteredSigTasks.length === 0) {
            return;
          }
          const proceed = confirm(
            `Would you also like to add this signature to ${filteredSigTasks.length} additional tasks?`
          );
          if (!proceed) {
            return; // user cancelled → stop here
          }
        }

        console.log('selectedSignature', selectedSig);

        // Create an array of tasks to update
        const tasksToUpdate = filteredSigTasks.map(task => ({
          logbook_id: parseInt(logbookId),
          task_id: parseInt(task.task_id),
          ins_signature_id: selectedSig?.id || null,
        }));

        if (tasksToUpdate.length === 0) {
          console.log('No tasks require signature.');
          return;
        }

        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        // Make an Axios POST request to the batchUpdate API endpoint
        const response = await axios.post('/api/logbookentry/batch-update', {
          logbook_entries: tasksToUpdate
        }, { headers });

        console.log("Success in updating logbook entries:", response);

        // Update the affected rows immediately in place - no refetch needed
        filteredSigTasks.forEach(task => {
          task.ins_signature_id = selectedSig?.id || null;
        });

      } catch (error) {
        console.error('Error updating logbook entries:', error);
        alert('Failed to add the signature to the other tasks. Please try again.');
      }
    },
    findSignatureUrl(signatureId) {
      const signature = this.signatures.find(sig => sig.id === signatureId);
      if (signature && signature.user_image) {
        return `data:image/jpeg;base64,${signature.user_image}`;
      } else {
        return null;
      }
    },
    findInstSignatureUrl(instSignatureId) {
      const signature = this.signatures.find(sig => sig.id === instSignatureId);
      if (signature && signature.user_image) {
        return `data:image/jpeg;base64,${signature.user_image}`;
      } else {
        return null;
      }
    },
    onPageChange(newPage) {
      this.currentPage = newPage;
    },
    async toggleEnabled(task) {
      const logbookId = localStorage.getItem('logbook_id');
      const instId = parseInt(localStorage.getItem('user_id'));
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      if (!task.enabled) {
        const confirmation = window.confirm('Are you sure you want to disable this task?');
        if (!confirmation) {
          task.enabled = true;
          return;
        }
      }
      try {
        if (!task.enabled) {
          // Disable the task
          await axios.delete(`/api/logbookentry/delete/${logbookId}/${task.task_id}`, { headers });
        } else {
          // Enable the task or create a new record if it doesn't exist
          await axios.post(`/api/logbookentry`, {
            logbook_id: logbookId,
            task_id: task.task_id,
            enabled: true,
            ins_enabled_id: instId,
            is_submitted: false,
            is_revoked: false,
            is_selected: 0,
          }, { headers });
        }
      } catch (error) {
        console.error("Error toggling task:", error);
      }
    },
    async setSelectedTimestamp(task, selectedDate = new Date()) {
      const formattedDate = this.formatDate(selectedDate);
      const logbookId = localStorage.getItem('logbook_id');
      const userId = localStorage.getItem('user_id');
      const token = localStorage.getItem('token');

      if (!logbookId || !userId || !token) {
        console.error('Missing required authentication or logbook data');
        return;
      }

      // Remember previous state so we can roll back if the request fails
      const previousSelectedDate = task.selected_date;
      const previousEnabled = task.enabled;
      const previousInsEnabledId = task.ins_enabled_id;
      const previousInstructorEnabledName = task.instructor_enabled_name;

      // Optimistic update - reflect the assignment in the UI immediately,
      // no refetch of the whole logbook required.
      task.selected_date = formattedDate;
      task.enabled = true;
      task.ins_enabled_id = userId;
      task.instructor_enabled_name = this.instructor
        ? `${this.instructor.last_name}, ${this.instructor.first_name}`
        : previousInstructorEnabledName;

      const headers = { Authorization: `Bearer ${token}` };

      try {
        let response;

        if (task.logbookentry_id) {
          // ✅ UPDATE existing logbook entry
          response = await axios.put(`/api/logbookentry/${logbookId}/${task.task_id}`, {
              enabled: true,
              selected_date: formattedDate,
              ins_enabled_id: userId,
              entry_P1: task.entry_P1,
              entry_P2: task.entry_P2,
            },
            { headers }
          );
          console.log('Success in updating logbook entry:', response);
        } else {
          // Create new logbook entry
          response = await axios.post(
            `/api/logbookentry`,
            {
              logbook_id: logbookId,
              task_id: task.task_id,
              enabled: true,
              selected_date: formattedDate,
              ins_enabled_id: userId,
              entry_P1: task.entry_P1,
              entry_P2: task.entry_P2,
              is_submitted: false,
              is_revoked: false,
              is_selected: 0,
            },
            { headers }
          );
          console.log('Success in creating logbook entry:', response);
          // A brand-new entry needs its id locally so notes/sign-off actions
          // (which key off logbookentry_id) keep working without a refetch.
          task.logbookentry_id = response.data?.id ?? null;
        }

        this.noteOwnChange(response.data?.updated_at);
      } catch (error) {
        console.error('Error saving logbook entry:', error.response?.data || error);
        // Roll back the optimistic update since the server call failed
        task.selected_date = previousSelectedDate;
        task.enabled = previousEnabled;
        task.ins_enabled_id = previousInsEnabledId;
        task.instructor_enabled_name = previousInstructorEnabledName;
        alert('Failed to assign the task. Please try again.');
      }
    },
    async setTimestamp(task, selectedDate = new Date()) {
      const formattedDate = this.formatDate(selectedDate);
      const logbookId = localStorage.getItem('logbook_id');
      const userId = localStorage.getItem('user_id');  // Retrieve user_id from localStorage
      const selectedSig = this.findSelectedSignatureForUser(parseInt(userId));
      console.log('selectedSig', selectedSig);

      // Remember previous state so we can roll back if the request fails
      const previousInsSo = task.ins_so;
      const previousInsSignatureId = task.ins_signature_id;
      const previousInstructorId = task.instructor_id;
      const previousInstructorName = task.instructor_name;
      const previousReadOnly = task.isReadOnly;

      // Optimistic update - reflect the sign-off in the UI immediately,
      // no refetch of the whole logbook required.
      task.ins_so = formattedDate;
      task.isReadOnly = true;
      task.instructor_id = userId;
      task.instructor_name = this.instructor ? `${this.instructor.last_name}, ${this.instructor.first_name}` : previousInstructorName;
      if (selectedSig) {
        task.ins_signature_id = selectedSig.id;
      }

      try {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };
        const response = await axios.put(`/api/logbookentry/${logbookId}/${task.task_id}`, {
          ins_so: formattedDate,
          instructor_id: userId,
          ins_signature_id: selectedSig?.id || null,
          entry_P1: task.entry_P1,
          entry_P2: task.entry_P2,
        }, { headers });
        console.log("Success in updating logbook entry:", response);
        this.noteOwnChange(response.data?.updated_at);
        // Note: auto-stamping the signature onto other completed tasks
        // (addSigToTasks) is intentionally not triggered here - left disabled
        // as it was before, since a full refetch is no longer needed anyway.
      } catch (error) {
        console.error("Error updating logbook entry:", error);
        // Roll back the optimistic update since the server call failed
        task.ins_so = previousInsSo;
        task.ins_signature_id = previousInsSignatureId;
        task.instructor_id = previousInstructorId;
        task.instructor_name = previousInstructorName;
        task.isReadOnly = previousReadOnly;
        alert('Failed to sign off the task. Please try again.');
      }
    },
    async signOffAll(selectedDate = new Date()) {
      const formattedDate = this.formatDate(selectedDate);
      if (this.selectedTasks.length === 0) {
        alert('No tasks selected for sign-off.');
        return;
      }

      if (confirm('Are you sure you want to sign off on ' + this.selectedTasks.length + ' selected tasks?')) {
        try {
          const logbookId = localStorage.getItem('logbook_id');
          const userId = parseInt(localStorage.getItem('user_id'));
          const selectedSig = this.findSelectedSignatureForUser(userId);
          const instructorName = this.instructor ? `${this.instructor.last_name}, ${this.instructor.first_name}` : '';

          const tasksToUpdate = this.selectedTasks.map(task => {
            return {
              logbook_id: parseInt(logbookId),
              task_id: parseInt(task.task_id),
              ins_so: formattedDate,
              instructor_id: userId,
              ins_signature_id: selectedSig?.id || null,
            };
          });

          const token = localStorage.getItem('token');
          const headers = { Authorization: `Bearer ${token}` };

          // Make an Axios POST request to the batchUpdate API endpoint
          await axios.post('/api/logbookentry/batch-update', {
            logbook_entries: tasksToUpdate
          }, { headers });

          // Reflect the sign-off on every selected row immediately - no refetch needed
          this.selectedTasks.forEach(task => {
            task.ins_so = formattedDate;
            task.instructor_id = userId;
            task.instructor_name = instructorName;
            if (selectedSig) {
              task.ins_signature_id = selectedSig.id;
            }
          });

          // Clear the selectedTasks array after successful sign-off
          this.selectedTasks = [];
        } catch (error) {
          console.error('Error signing off tasks:', error);
          // You can handle the error here, e.g., show an error message to the user
          alert('Error signing off tasks: ' + error.response.data.message);
        }
      }
    },
    formatDate(date) {
      const d = (date instanceof Date) ? date : new Date(date);

      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      const hours = String(d.getHours()).padStart(2, '0');
      const minutes = String(d.getMinutes()).padStart(2, '0');
      const seconds = String(d.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // Everything the page needs in one call. entriesOnly skips the parts that don't change
    // after an edit (trainee, product, evaluations, chapters)
    async fetchPageData(entriesOnly = false) {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
      const logbookId = localStorage.getItem('logbook_id');
      const params = entriesOnly ? { only: 'entries' } : {};

      const { data } = await axios.get(`/api/instructor/logbooks/${logbookId}/page`, { headers, params });

      this.logbookName = data.logbook.name;
      this.locked = data.logbook.locked;
      this.tasks = data.tasks || [];
      this.logbookEntries = data.entries || [];
      this.notes = data.notes || [];
      this.revokes = data.revokes || [];
      this.instructors = data.instructors || [];
      this.instructor = this.instructors.find(user => user.user_id === parseInt(this.user_id));
      this.signatures = data.signatures || [];
      this.lastKnownUpdate = data.last_updated;

      if (!entriesOnly) {
        this.trainee = data.trainee || [];
        this.trainee_evaluations = data.evaluations || [];
        this.chapters = data.chapters || [];
        if (data.product) {
          this.currentProduct = data.product;
          localStorage.setItem('currentProduct', JSON.stringify(data.product));
        }
      }

      this.MTCount = this.tasks.filter(task => task.manob === 'MT').length;

      this.mergeData();
    },
    async fetchData() {
      try {
        await this.fetchPageData(true);
      } catch (error) {
        console.error('An error occurred while fetching data:', error);
        this.tasks = [];
        this.logbookEntries = [];
        this.notes = [];
        this.mergeData();
      }
    },

    // Lightweight poll: ask the server for a single timestamp representing the
    // latest change to this logbook (entries/notes/revokes/lock state). Only
    // pulls the full logbook data (5 requests) when that timestamp has
    // actually moved on, instead of unconditionally refetching everything on
    // a timer.
    // Poll a single lightweight "has anything changed" endpoint every 60s
    // instead of unconditionally refetching the whole logbook. Skipped while
    // the tab isn't visible; visibility regain triggers an immediate check.
    startPolling() {
      if (this.refreshInterval) return;
      this.refreshInterval = setInterval(() => {
        if (!document.hidden) {
          this.checkForUpdates();
        }
      }, 60000);
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
    },
    stopPolling() {
      if (this.refreshInterval) {
        clearInterval(this.refreshInterval);
        this.refreshInterval = null;
      }
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    },
    async checkForUpdates() {
      const logbookId = localStorage.getItem('logbook_id');

      // Safety net: never keep polling once the page is gone or there's no logbook (e.g. after logout)
      if (this.isUnmounted || !logbookId || logbookId === 'null') {
        this.stopPolling();
        return;
      }

      if (this.isCheckingForUpdates) return; // don't stack overlapping checks
      this.isCheckingForUpdates = true;

      try {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        const response = await axios.get(`/api/logbooks/${logbookId}/last-updated`, { headers });
        const latest = response.data.last_updated;

        if (latest && latest !== this.lastKnownUpdate) {
          await this.fetchData();
          this.lastKnownUpdate = latest;
        }
      } catch (error) {
        console.error('Error checking for logbook updates:', error);
      } finally {
        this.isCheckingForUpdates = false;
      }
    },

    // Record the timestamp of a change we just made ourselves, so the next
    // lightweight poll doesn't mistake our own update for a remote one and
    // trigger a redundant full refetch.
    noteOwnChange(timestamp) {
      if (!timestamp) return;
      if (!this.lastKnownUpdate || new Date(timestamp) > new Date(this.lastKnownUpdate)) {
        this.lastKnownUpdate = timestamp;
      }
    },

    handleVisibilityChange() {
      if (!document.hidden) {
        // Tab just became active again - catch up immediately rather than
        // waiting for the next timer tick.
        this.checkForUpdates();
      }
    },

    mergeData() {
      const logbookEntries = this.logbookEntries || [];
      const instructors = this.instructors || [];
      const notes = this.notes || [];
      const revokes = this.revokes || [];
      const tasks = this.tasks || [];

      this.mergedTasks = tasks.map(task => {
        const matchingEntry = logbookEntries.find(entry => entry.task_id === task.task_id);

        const matchingInstructor = instructors.find(
          instructor => instructor.user_id === matchingEntry?.instructor_id
        );

        const matchingEnabledInstructor = instructors.find(
          instructor => instructor.user_id === matchingEntry?.ins_enabled_id
        );

        const matchingNotes = notes.filter(
          note => note.logbookentry_id === matchingEntry?.id
        );

        const matchingRevoke = revokes.find(
          r => r.logbookentry_id === matchingEntry?.id
        );

        return {
          ...task,
          logbookentry_id: matchingEntry ? matchingEntry.id : null,
          completed: matchingEntry ? matchingEntry.completed : null,
          ins_so: matchingEntry ? matchingEntry.ins_so : null,
          selected_date: matchingEntry ? matchingEntry.selected_date : null,
          enabled: matchingEntry ? matchingEntry.enabled === 1 : 0,
          ins_enabled_id: matchingEntry ? matchingEntry.ins_enabled_id : null,
          instructor_id: matchingEntry ? matchingEntry.instructor_id : null,
          ac_reg: matchingEntry ? (matchingEntry.ac_reg ?? matchingEntry.initial_ac_reg ?? '') : '',
          jobcard_no: matchingEntry ? matchingEntry.jobcard_no : null,
          entry_P1: matchingEntry ? matchingEntry.entry_P1 === 1 : 0,
          entry_P2: matchingEntry ? matchingEntry.entry_P2 === 1 : 0,
          is_selected: matchingEntry ? matchingEntry.is_selected : null,
          is_revoked: matchingEntry ? matchingEntry.is_revoked : null,
          is_inst_revoked: matchingRevoke ? matchingRevoke.is_instructor_signoff : null,
          t_signature_id: matchingEntry ? matchingEntry.t_signature_id : null,
          ins_signature_id: matchingEntry ? matchingEntry.ins_signature_id : null,
          instructor_enabled_name: matchingEnabledInstructor
            ? `${matchingEnabledInstructor.last_name}, ${matchingEnabledInstructor.first_name}`
            : '',
          instructor_name: matchingInstructor
            ? `${matchingInstructor.last_name}, ${matchingInstructor.first_name}`
            : '',
          instructor_license: matchingInstructor ? matchingInstructor.license_no : '',
          notes: matchingNotes,
        };
      });
      this.completedMTCount = this.mergedTasks.filter(task => task.manob === 'MT' && task.ins_so).length;
    },
    async openEditor(logbookentryId, isPublic = false) {
      // Update the current task ID
      this.logbookentryId = logbookentryId;
      this.isNotePublic = isPublic;  // Set the note type

      if (this.isNotePublic) {
        this.noteType = 'public'
      } else {
        this.noteType = 'private'
      }

      this.showQuillEditor = true;
    },
    closeQuillEditor() {
      this.showQuillEditor = false;
      this.fetchData();
    },
    confirmSignOff(task) {
      if (!task.entry_P1 && !task.entry_P2) {
        alert('Please select either Classroom or Aircraft before signing off.');
        return;
      }
      if (!this.findSelectedSignatureForUser(parseInt(localStorage.getItem('user_id')))) {
        alert('You must save a signature before signing off a task.\n\nPlease add one to your profile before signing off.');
        this.goBack(true);
        return;
      }
      if (confirm('Are you sure you want to sign off?')) {
        this.setTimestamp(task);
      }
    },
    toggleMultiSignOffMode() {
      if (this.multiSignOffMode) {
        // If currently in Multi-Sign Off mode, exit it
        this.multiSignOffMode = false;
        this.selectedTasks = [];
      } else {
        // If not in Multi-Sign Off mode, switch to Select All mode
        this.multiSignOffMode = true;
        // Perform the "Select All" action here
        this.toggleAllTasksSelection();
      }
    },
    toggleSignOff(task) {
      if (task.selectedForSignOff) {
        this.selectedTasks.push(task);
      } else {
        const index = this.selectedTasks.findIndex((selectedTask) => selectedTask.task_id === task.task_id);
        if (index !== -1) {
          this.selectedTasks.splice(index, 1);
        }
      }
    },
    toggleAllTasksSelection() {
      this.selectedTasks = [];

      this.filteredTasks.forEach(task => {
        if (task.completed && !task.ins_so) {
          task.selectedForSignOff = true;
          this.selectedTasks.push(task);
        }
      });

      if (this.selectedTasks.length === 0) {
        alert("All tasks have already been signed off.");
        this.multiSignOffMode = false;
      }
    },
    updateOnlineStatus() {
      this.isOffline = !navigator.onLine;
    },
    async openChooseAssessmentModal() {
      this.showChooseAssessmentModal = true;
    },
    closeChooseAssessmentModal() {
      this.showChooseAssessmentModal = false;
      this.fetchData();
    },
    openInsTaskLongFormModal(task) {
      this.currentTask = task;
      console.log('this.currentTask');
      console.log(this.currentTask);
      this.showInsTaskLongFormModal = true;
    },
    closeInsTaskLongFormModal() {
      this.showInsTaskLongFormModal = false;
    },
    openTraineeProgressModal() {
      this.showTraineeProgressModal = true;
    },
    closeTraineeProgressModal() {
      this.showTraineeProgressModal = false;
    },
    openLogbookRulesModal() {
      this.showLogbookRulesModal = true;
    },
    closeLogbookRulesModal() {
      this.showLogbookRulesModal = false;
    },
    revokeSignOff(task, insSo) {
      if (confirm('Are you sure you want to revoke this sign off? \nThis action cannot be undone')) {
        this.openRevokeSignOffModal(task, insSo);
      }
    },
    openRevokeSignOffModal(task, insSo, viewOnly = false) {
      console.log('task', task);
      this.currentTaskId = task.task_id;
      this.logbookentryId = task.logbookentry_id;
      this.signOff = task.completed;
      this.is_inst_so = insSo;
      this.viewOnlyRevoke = viewOnly;
      this.showRevokeSignOffModal = true;
    },
    closeRevokeSignOffModal() {
      this.showRevokeSignOffModal = false;
      this.viewOnlyRevoke = false;
      this.fetchData();
    },
    openChooseSignOffDateModal(task, type) {
      this.signOffType = type;

      if (type === 'multi') {
        // Multi sign-off mode (no specific task)
        this.currentTask = null;
        this.currentTaskId = null;
        this.logbookentryId = null;
      } else {
        // Single task sign-off
        this.currentTask = task;
        this.currentTaskId = task.task_id;
        this.logbookentryId = task.logbookentry_id;
      }

      this.showChooseSignOffDateModal = true;
    },
    closeChooseSignOffDateModal() {
      // Note: the modal emits 'close' right alongside 'signOffDateSelected'/
      // 'multiDateSelected' on submit, so this also fires after a successful
      // save. Those handlers already update the UI optimistically, so no
      // refetch is needed here - this just handles the flag toggle for both
      // the "Close" (cancel) button and post-submit cleanup.
      this.showChooseSignOffDateModal = false;
    },
    async handleSignOffDateSelected({ taskId, selectedDate }) {
      if (!this.currentTask || this.currentTask.task_id !== taskId) return;

      const dateObj = new Date(selectedDate);
      await this.setSelectedTimestamp(this.currentTask, dateObj);

      this.showChooseSignOffDateModal = false;
    },
    async handleMultiSignOffDateSelected(selectedDate) {
      await this.signOffAll(new Date(selectedDate));
      this.showChooseSignOffDateModal = false;
    },
    openSignatureModal(event) {
      try {
        this.showSignatureModal = true;
      } catch (error) {
        console.error('Error opening signature modal:', error);
        // If `error` is actually an Event object, this will help surface more info.
        console.error('Event details:', event);
      }
    },
    async closeSignatureModal() {
      this.showSignatureModal = false;
      // addSigToTasks() reuses this.signatures, so refresh it (a signature may
      // have just been added) before relying on it.
      await this.fetchData();
      this.addSigToTasks();
    },
    async showPDFReport() {
      this.displayLogbookReport = true;

      setTimeout(() => {
        this.displayLogbookReport = false;
      }, 100);
    },
    // async openTaskAssessmentModal(task) {
    //   if (!task.completed) {
    //     alert('The trainee must sign off on the task before they can be assessed')
    //     return;
    //   }
    //   if (task.is_selected === 0) {
    //     if (confirm('Do you want to select this task to be assessed?')) {
    //       const token = localStorage.getItem('token');
    //       const headers = { Authorization: `Bearer ${token}` };
    //       const logbookId = localStorage.getItem('logbook_id');

    //       const response = await axios.put(`/api/logbookentry/${logbookId}/${task.task_id}`, {
    //         is_selected: 1
    //       }, { headers });
    //       console.log("Success in updating logbook entry:", response);
    //       this.fetchData();
    //       return;
    //     } else {
    //       return;
    //     }
    //   }
    //   this.fetchedTaskAssessmentData = null;
    //   this.tasksCompleted = this.completedMTCount || 0;
    //   this.selectedTask = task;
    //   console.log('Selected Task:', this.selectedTask);
    //   this.fetchTraineeTaskAssessment(task);
    //   this.showTaskAssessmentModal = true;
    // },
    // closeTaskAssessmentModal() {
    //   this.showTaskAssessmentModal = false;
    //   this.fetchData();
    // },
    fetchEvaluationData() { 
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };
      const logbookId = parseInt(this.logbookId);

      axios.get(`/api/evaluations/logbooks/${logbookId}`, { headers })
        .then(response => {
          console.log('evaluations response:', response.data);

          if (Array.isArray(response.data)) {
            this.trainee_evaluations = response.data;
          } else if (Array.isArray(response.data?.data)) {
            this.trainee_evaluations = response.data.data;
          } else if (response.data) {
            this.trainee_evaluations = [response.data];
          } else {
            this.trainee_evaluations = [];
          }
        })
        .catch(error => {
          console.error('There was an error fetching the evaluation:', error);
          this.trainee_evaluations = [];
        });
    },
    openChooseEvaluationModal() {
      this.showChooseEvaluationModal = true;
      this.tasksCount = this.MTCount;
      this.tasksCompleted = this.completedMTCount || 0;
    },
    closeChooseEvaluationModal(submit = false) {
      this.showChooseEvaluationModal = false;
      if (submit === true) {
        this.locked = 1;
      }
      this.fetchEvaluationData();
    },
  },
  async mounted() {
    this.user_id = localStorage.getItem('user_id');  // Retrieve and store user_id
    if (!this.user_id) {
      console.error("user_id not found");
      return;  // Handle the absence of user_id appropriately
    }

    const isAssessor = localStorage.getItem('isAssessor');
    const isAssessorSelected = JSON.parse(isAssessor);
    this.isAssessorSelected = isAssessorSelected;
    this.$route.params.logbookId;
    this.$route.params.productId;
    this.$route.params.traineeId;
    window.addEventListener('online', this.syncData);
    window.addEventListener('online', this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);

    // One call for the whole page. It also returns the freshness baseline
    // (last_updated) the polling below compares against.
    try {
      await this.fetchPageData();
    } catch (error) {
      console.error('An error occurred while fetching logbook data:', error);
    }

    // The user may have left the page while the data was loading
    if (this.isUnmounted) return;

    this.startPolling();

    await this.$nextTick();
    if (isAssessorSelected) {
      this.selectedCompleted = 'completed tasks';
      this.selectedisexam = true;
    }
  },
  beforeUnmount() {
    this.isUnmounted = true;
    this.stopPolling();
    window.removeEventListener('online', this.syncData);
    window.removeEventListener('online', this.updateOnlineStatus);
    window.removeEventListener('offline', this.updateOnlineStatus);
  },
}
</script>

<style scoped>
.data-table-instructor-logbook .P1 {
  width: 1%;
}

img {
  width: 100%;
  height: 30%;
  border: 1px solid lightgray;
}

.signatureButton {
  margin-right: 20px;
  float: right;
}

.icon-green {
  color: rgb(21, 185, 21);
  fill: green
}

.signature-container,
.ins-signature-container {
  width: 100px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #000;
}

.ins-signature-image,
.signature-image {
  width: 100%;
  height: 100%;
}

.inspdfButton {
  border-radius: 5px;
  width: 150px;
  background-color: #a52c0d;
  color: white;
  padding: 5px;
  font-size: 16px;
  border: 1px solid #491204;
  float: right;
}

.inspdfButton:hover {
  background-color: #791e08;
}

.back-button {
  /* Adjust the right position as needed */
  width: 100px;
  border-radius: 5px;
  background-color: #c1e0bf;
  font-size: 14px;
  border: 2px solid black;
  padding: 3px;
}

.back-button:hover {
  background-color: #abc7a9;
  cursor: pointer;
}

.chapter-row {
  border: 1px solid rgb(2, 23, 63);
}

.chapter-name-cell {
  background-color: rgba(38, 65, 116, 0.884);
  border: 1px solid rgb(2, 23, 63);
  color: white;
  text-align: center;
}

.select-P1-P2 {
  font-size: 16px;
  height: 30px;
  border: 1px solid #afafaf;
  border-radius: 3px;
}

input:disabled,
button:disabled {
  cursor: not-allowed;
  opacity: 0.7;
  transition: none;
  transform: none;
}

.delete-icon.disabled-icon {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.7;
  filter: grayscale(100%);
}

.addSigButton {
  margin-right: 20px;
  border-radius: 5px;
  width: 200px;
  background-color: #6890ff;
  color: white;
  padding: 5px;
  font-size: 16px;
  border: 1px solid #395192;
}

.addSigButton:hover {
  background-color: #395192;
}

.flex-grow-1 {
  max-height: 40px;
}
</style>